import {formatDate, getComputedValue, isJsonString, stripHtml, truncateString, roundToDecimal} from "@/js/utils";
import {config} from "@/config/config";
import {VueComponentControl} from "@/js/Map/control/VueComponentControl";


export default {
  methods: {
    renderValue(value, document, properties, fieldName, truncateValues = false) {
      if (value && value !== "null") {
        let fieldCode;
        if (fieldName && document?.properties?.header[fieldName]) {
          fieldCode = document?.properties?.header[fieldName].dataType.code;
        }

        if (fieldCode === "date") {
          return formatDate(value, "ro", "DD-MM-YYYY");
        }

        // check if value is a stringified json a list type attribute that saves data as object
        if (
          fieldCode &&
          ["list", "multilist", "checklist"].includes(fieldCode) &&
          document?.properties?.header[fieldName]?.properties?.dataSource?.valueType === "object" &&
          document?.properties?.header[fieldName]?.properties?.dataSource?.labelField
        ) {
          const fieldVal = isJsonString(value) ? JSON.parse(value) : value;
          if (["multilist", "checklist"].includes(fieldCode)) {
            if (Array.isArray(fieldVal)) {
              return fieldVal.map((item) => {
                if (
                  item &&
                  item.hasOwnProperty(document?.properties?.header[fieldName]?.properties?.dataSource?.labelField)
                ) {
                  return item[document?.properties?.header[fieldName]?.properties?.dataSource?.labelField];
                }
              });
            }
          } else {
            if (
              fieldVal &&
              fieldVal.hasOwnProperty(document?.properties?.header[fieldName]?.properties?.dataSource?.labelField)
            ) {
              return fieldVal[document?.properties?.header[fieldName]?.properties?.dataSource?.labelField];
            }
          }
        }

        /*if ((fieldCode && fieldCode === 'computed') || String(value).match(/\$\{\S+\}/g)) {
          return this.getComputedValue(value, properties)
        }*/

        try {
          const jsonValue = Array.isArray(value)
            ? value
            : isJsonString(value)
              ? JSON.parse(value)
              : truncateValues
                ? truncateString(stripHtml(value), 60)
                : value;


          if (fieldCode === "plant") {
            return `<div class="plant-card">
                  ${jsonValue.images && jsonValue.images.length ?
                ` <div class="plant-image" >
                  <img alt="${jsonValue.plantName}" src="${jsonValue.images[0].url}"/>
                </div> ` : ``}
                <div class="plant-details">
                ${jsonValue.plantName ? ` <div  class="plant-title">
                    ${jsonValue.plantName}
                  </div> ` : ``}
                  <div class="plant-info">
                  ${jsonValue.probability ? `<div>${this.$t('Probability')}: ${roundToDecimal(jsonValue.probability * 100)}%</div> ` : ``}
                  ${jsonValue.hasOwnProperty('confirmed') ? ` <div >${this.$t('Confirmed')}: ${jsonValue.confirmed}</div> ` : ``}
                  </div>
                </div>
              </div>`
          }

          if (Array.isArray(jsonValue)) {
            let html = "";
            for (let key = 0; key < jsonValue.length; key++) {
              html += this.renderValue(JSON.stringify(jsonValue[key]), document, properties, fieldName);
            }
            return truncateValues ? truncateString(stripHtml(html), 60) : html;
          } else if (jsonValue && typeof jsonValue === "object") {
            let html = "";
            for (let key in jsonValue) {
              html += `<div><strong>${key}</strong></div><div class="mb-2">${this.renderValue(
                jsonValue[key],
                document,
                properties,
                fieldName
              )}</div>`;
            }
            return truncateValues ? truncateString(stripHtml(html), 60) : html;
          } else {
            if (this.isImage(value)) {
              return `<a href="${this.getFileUrl(
                value,
                false,
                document
              )}" class="external" target="_blank"><img src="${this.getFileUrl(
                value,
                false,
                document
              )}" class="feature-image"></a>`;
            } else if (this.isFile(value)) {
              return /\.pdf$/gi.test(value)
                ? `<a href="${this.getFileUrl(value, false, document)}" class="external as-mask" target="_blank"></a>
                <object data="${this.getFileUrl(
                  value,
                  false,
                  document
                )}" type="application/pdf" width="100%" height="400px">
                  <a href="${this.getFileUrl(
                    value,
                    false,
                    document
                  )}" class="external" target="_blank">${this.getFileUrl(value, true, document)}</a>
                </object>`
                : `<a href="${this.getFileUrl(
                  value,
                  false,
                  document
                )}" class="external" target="_blank">${this.getFileUrl(value, true, document)}</a>`;
            } else {
              return `${truncateValues ? truncateString(stripHtml(value), 60) : value}`;
            }
          }
        } catch (e) {
          if (this.isImage(value)) {
            return `<a href="${this.getFileUrl(
              value,
              false,
              document
            )}" class="external" target="_blank"><img src="${this.getFileUrl(
              value,
              false,
              document
            )}" class="feature-image"></a>`;
          } else if (this.isFile(value)) {
            return /\.pdf$/gi.test(value)
              ? `<a href="${this.getFileUrl(value, false, document)}" class="external as-mask" target="_blank"></a>
                <object data="${this.getFileUrl(
                value,
                false,
                document
              )}" type="application/pdf" width="100%" height="400px">
                  <a href="${this.getFileUrl(
                  value,
                  false,
                  document
                )}" class="external" target="_blank">${this.getFileUrl(value, true, document)}</a>
                </object>`
              : `<a href="${this.getFileUrl(
                value,
                false,
                document
              )}" class="external" target="_blank">${this.getFileUrl(value, true, document)}</a>`;
          } else {
            return `${truncateValues ? truncateString(stripHtml(value), 60) : value}`;
          }
        }
      } else if (value !== "" && value !== null && value !== "null") {
        return `${truncateValues ? truncateString(stripHtml(value), 60) : value}`;
      } else {
        return "<span>&#8203;</span>";
      }
    },
    openPlantPopup(data) {
    },
    isImage(value) {
      return /(png|jpg|jpeg|gif)$/gi.test(value);
    },
    isFile(value) {
      return /(doc|docx|ppt|pdf|odt|shp|geojson|txt)$/gi.test(value) && !this.isImage(value);
    },
    getFileUrl(value, short, document) {
      let newUrl;
      if (value && value.includes("file:///")) value = value.replace("file:///", "");
      const fileNameShort =
        value.indexOf("/") > -1 ? String(value).split("/").slice(-1)[0] : String(value).split("\\").slice(-1)[0];
      if (this.isFile(value) || this.isImage(value)) {
        if (short) {
          return fileNameShort;
        } else if (/^[a-zA-Z]{1}:(\/|\\)/gi.test(value)) {
          newUrl =
            config.APP_TRANSFORM_STORAGE_URL &&
              this.common?.configs?.fileStorageUrl &&
              !new URL(this.common?.configs?.fileStorageUrl).host.includes(window.location.host)
              ? this.common?.configs?.fileStorageUrl.replace(
                new URL(this.common?.configs?.fileStorageUrl).host,
                window.location.host
              )
              : this.common?.configs?.fileStorageUrl;
          return newUrl + "/" + (document ? document.documentId + "/" : "") + fileNameShort;
        } else if (!/^http/gi.test(value)) {
          newUrl =
            config.APP_TRANSFORM_STORAGE_URL &&
              this.common?.configs?.fileStorageUrl &&
              !new URL(this.common?.configs?.fileStorageUrl).host.includes(window.location.host)
              ? this.common?.configs?.fileStorageUrl.replace(
                (new URL(this.common?.configs?.fileStorageUrl).host, window.location.host)
              )
              : this.common?.configs?.fileStorageUrl;
          return newUrl + "/" + (document ? document.documentId + "/" : "") + value;
        } else {
          return value;
        }
      }
    },
    isDataSourceField(field, document) {
      return document?.properties?.header[field.field]?.dataType?.code === "dataSource";
    },
    isDataCollectorField(field, document) {
      return document?.properties?.header[field.field]?.dataType?.code === "dataCollector";
    },
    async getDataCollection(field, data, loaderId) {
      this.isLoadingDataSource = loaderId || field.field;
      try {
        //let relatedAttributes = data?.attributes?[field?.field]?.value?.relatedAttributes;
        let dataSourceData = await this.getDataSourceData(field, data);
        const intersections = field?.value?.relatedDocumentIds?.length
          ? await this.getGeometryIntersections(field, data)
          : [];
        if (dataSourceData) {
          //let parameters = await this.prepareParameters(intersections.length ? intersections : this.data);
          dataSourceData.documentDetails.forEach((d) => {
            d.title = d.title.interpolateObject(intersections.length ? intersections[0] : {});
          });
          this.dataSourceDocument = dataSourceData;
          if (this.isDataSourceField(field, data.document) && data?.attributes[field.field]?.value?.versionData)
            this.showDocumentsPopup = true;
          else this.showNomenclaturePopup = true;
          this.isLoadingDataSource = null;
        } else {
          this.isLoadingDataSource = null;
          this.$toast.add({
            severity: "error",
            summary: "Error",
            detail: this.$t("Data source detail endpoint is not set!"),
            life: 5000,
          });
        }
      } catch (error) {
        this.isLoadingDataSource = null;
        this.$toast.add({
          severity: "error",
          summary: "Error",
          detail: error,
          life: 5000,
        });
      }
    },
    async getDataSourceDocument(field, data, loaderId) {
      this.isLoadingDataSource = loaderId || field.field;
      try {
        let dataSourceData = await this.getDataSourceData(field, data);
        const intersections = data?.attributes[field.field]?.value?.relatedDocumentIds?.length
          ? await this.getGeometryIntersections(field, data)
          : [];
        if (dataSourceData) {
          let organization = await this.$store.dispatch("getCompany", {
            query: {organizationId: data.document.organizationId},
            headers: {
              "x-access-token": this.mapController?.configuration?.accessToken,
            }
          });
          let organizationSettings = await this.$store.dispatch("getOrganizationSettings", {
            query: {organizationId: organization.organizationId},
            headers: {
              "x-access-token": this.mapController?.configuration?.accessToken,
            }
          });
          let organizationEmployees = await this.$store.dispatch("getEmployees", {
            query: {organizationId: organization.organizationId},
            headers: {
              "x-access-token": this.mapController?.configuration?.accessToken,
            }
          });
          dataSourceData.documentDetails.forEach((d) => {
            d.title = d.title.interpolateObject({
              ...(intersections.length ? intersections[0] : {}),
              organization,
              organizationSettings,
              organizationEmployees,
            });
          });
          this.dataSourceDocument = dataSourceData;
          if (this.isDataSourceField(field, data.document) && data?.attributes[field.field]?.value?.versionData)
            this.showDocumentsPopup = true;
          else this.showNomenclaturePopup = true;
          this.isLoadingDataSource = null;
        } else {
          this.isLoadingDataSource = null;
          this.$toast.add({
            severity: "error",
            summary: "Error",
            detail: this.$t("Data source detail endpoint is not set!"),
            life: 5000,
          });
        }
      } catch (error) {
        this.isLoadingDataSource = null;
        this.$toast.add({
          severity: "error",
          summary: "Error",
          detail: error,
          life: 5000,
        });
      }
    },
    async getGeometryIntersections(field, data) {
      return new Promise((resolve, reject) => {
        this.$store
          .dispatch("getIntersectedGeometries", {
            data: {
              geometryIds: [data.geometryId],
              relatedDocumentIds: data?.attributes[field.field]?.value?.relatedDocumentIds,
              asFeature: true,
              processAttributes: true,
            },
            headers: {
              "x-access-token": this.mapController?.configuration?.accessToken,
            }
          })
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    getDataSourceData(field, data) {
      return new Promise((resolve, reject) => {
        try {
          if (this.isDataSourceField(field, data.document)) {
            const fieldValue = isJsonString(field.value)
              ? JSON.parse(field?.value).value
              : field.value && field.value.value
                ? field.value.value
                : field.value;
            let endpointData = {};
            endpointData.url = String(data?.attributes[field.field]?.value?.detailEndpoint).replace(
              /\${documentId}/g,
              fieldValue
            );
            endpointData.method = data?.attributes[field.field]?.value?.detailEndpointMethod;
            endpointData.requestType = data?.attributes[field.field]?.value?.requestType;
            // get endpoint filters based on relatedAttributes
            const relatedAttributes = data?.attributes[field.field]?.value?.relatedAttributes;
            if (relatedAttributes && relatedAttributes.length) {
              if (data.properties && Object.keys(data.properties).length) {
                endpointData.params = {};
                for (let attr in data.properties) {
                  const param = this.getAttributeName(attr, data);
                  if (param && relatedAttributes.indexOf(this.getAttributeName(attr, data)) > -1) {
                    endpointData.params[param] = data.properties[attr];
                  }
                }
              }
            }
            if(!endpointData.headers) {
              endpointData.headers = {
                "x-access-token": this.mapController?.configuration?.accessToken,
              }
            }

            if (endpointData.url) {
              this.$store
                .dispatch("dataSourceCall", endpointData)
                .then((response) => {
                  resolve(response);
                })
                .catch((error) => {
                  this.isLoadingDataSource = null;
                  reject(error);
                });
            } else {
              resolve();
            }
          } else resolve();
        } catch (error) {
          reject(error);
        }
      });
    },
    async prepareParameters(data) {
      let parameters = {
        attributes: {},
        zoom: this?.mapProperties?.zoom,
        scale: this?.mapProperties?.scale,
        image: this?.mapProperties?.map.getCanvas().toDataURL(),
      };
      if (data) {
        await data.forEachAsync(async (d, index) => {
          if (d.properties)
            await Object.keys(d.properties).forEachAsync(async (key) => {
              let value;
              if (
                d.attributes &&
                d.attributes[key] &&
                d.attributes[key].dataType &&
                d.attributes[key].dataType.code === "dataSource"
              ) {
                let dataSourceData = await this.getDataSourceData(
                  {field: key, value: d.properties[key], groupId: null},
                  d
                );
                if (dataSourceData && dataSourceData.documentDetails) {
                  if (!value) value = "";
                  value = (value ? value + ", " : "") + this.getAllParagraphs(dataSourceData.documentDetails);
                  /*dataSourceData.documentDetails.forEach((dd) => {
                    value = (value ? value + ", " : "") + dd.title;
                  });*/
                }
              } else value = d.properties[key];

              if (d.attributes && d.attributes[key] && d.attributes[key].attributeId && this.standardAttributes) {
                let standardAttribute = this.standardAttributes.find(
                  (x) => x.attributeId === d.attributes[key].attributeId
                );
                if (standardAttribute) {
                  //console.log(d.attributes[key])
                  parameters.attributes[standardAttribute.title] =
                    (parameters.attributes[standardAttribute.title]
                      ? parameters.attributes[standardAttribute.title] +
                      (d.attributes[key]?.value?.splitByLayer ? " </br> " : "")
                      : "") +
                    (d.attributes[key]?.value?.splitByLayer
                      ? `<div font-size: 30px;><strong> ${d.document.title}: </strong></div>` + " </br> "
                      : "") +
                    value;
                } else {
                  //console.log(d.attributes[key])
                  parameters.attributes[key] =
                    (parameters.attributes[key]
                      ? parameters.attributes[key] + " " + (d.attributes[key]?.value?.splitByLayer ? " </br> " : "")
                      : "") +
                    (d.attributes[key]?.value?.splitByLayer
                      ? `<div font-size: 30px;><strong> ${d.document.title}: </strong></div>` + " </br> "
                      : "") +
                    value;
                }
              } else {
                //console.log(d.attributes[key])
                parameters.attributes[key] =
                  (parameters.attributes[key]
                    ? parameters.attributes[key] + " " + (d.attributes[key]?.value?.splitByLayer ? " </br> " : "")
                    : "") +
                  (d.attributes[key]?.value?.splitByLayer
                    ? `<div font-size: 30px;><strong> ${d.document.title}: </strong></div>` + " </br> "
                    : "") +
                  value;
              }

              //console.log(parameters.attributes[key])
            });
        });
      }
      return parameters;
    },
    getAllParagraphs(list) {
      let value;
      if (list) {
        list.forEach((dd) => {
          value = (value ? value + " " : "") + dd.title;
          if (dd.children) value = (value ? value + " " : "") + this.getAllParagraphs(dd.children);
        });
      }
      return value;
    },
    getAttributeName(field, data) {
      if (typeof field !== "string") field = field.field;

      const attr = data?.attributes[field];
      if (attr && attr.attributeId) {
        const attribute = this.standardAttributes.find((el) => el.attributeId === attr.attributeId);
        if (attribute) {
          return attribute.title;
        } else {
          return "";
        }
      } else {
        return field;
      }
    },
    getComputedValue(value, properties) {
      return getComputedValue(value, properties);
    },
  },
};
